module.exports = __webpack_public_path__ + "fonts/JuliusSansOne-Regular.1fce8b7c6b93fd22e08dca2d573c297d.ttf";